export default {
  SET_USER (state, user) {
    state.user = user
  },
  HIDE_MONTH_TO_MONTH_WIZARD (state) {
    state.user.showMonthToMonthWizard = false
  },
  SET_FCM_TOKEN (state, fcm_token) {
    state.user.fcm_token = fcm_token
  },
  SET_LANDBOT_MESSAGE_READ (state) {
    state.user.landbotMessage = false
  },
  SET_ACADEMY_REQUESTED (state) {
    console.log('mutation SET_ACADEMY_REQUESTED')
    state.user.academyRequested = true
  },
  SET_ADDITIONAL_INFO (state, info) {
    console.log('mutation SET_ACADEMY_REQUESTED', info)

    state.user.additionalInfo = { ...state.user.additionalInfo, ...info }
  },
  SET_QUOTE_RATED (state, ratedObject) {
    console.log('mutation SET_QUOTE_RATED', ratedObject)

    state.user.ratedQuotes = { ...state.user.ratedQuotes, ...ratedObject }
  },
  SET_TIP_RATED (state, ratedObject) {
    console.log('mutation SET_TIP_RATED', ratedObject)

    state.user.ratedTips = { ...state.user.ratedTips, ...ratedObject }
  },
  SET_COMMUNITY_TIP_RATED (state, ratedObject) {
    console.log('mutation SET_TIP_RATED', ratedObject)

    state.user.ratedCommunityTips = { ...state.user.ratedCommunityTips, ...ratedObject }
  },
  SET_FIRST_CHAPTER (state, firstChapter) {
    console.log('mutation SET_FIRST_CHAPTER', firstChapter)

    state.user.firstChapter = firstChapter
  },
  CHANGE_BACKGROUND (state, backgroundImageName) {
    console.log('mutation CHANGE_BACKGROUND', backgroundImageName)

    state.user.backgroundImageName = backgroundImageName
  },
  CHANGE_FILTER (state, filter) {
    console.log('mutation CHANGE_FILTER', filter)

    state.user.filter = filter
  }
}
